
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Bismuth_Corlette',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Bismuth_Corlette.vue